import http from "../../../../../core/utils/apis/api";

const getTrainingsService = async (searchQuery, page, take, includeUpcoming) => {
  try {
    const response = await http({
      method: "GET",
      url: "/trainings",
      params: {
        search: searchQuery,
        take: take,
        page: page,
        includeUpcoming: includeUpcoming,
      },
    });
    return response;
  } catch (e) {
    throw e;
  }
};

const filterUsersByRole = async (filter) => {
  try {
    const response = await http({
      method: "POST",
      url: "/users/filter",
      data: { filter: filter },
    });
    return response;
  } catch (e) {
    throw e;
  }
};

const createTraining = async (trainingData) => {
  try {
    const response = await http({
      method: "POST",
      url: `/trainings`,
      data: trainingData,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (e) {
    throw e;
  }
};
const addTraining = async (formData) => {
  try {
    const response = await http({
      method: "POST",
      url: `/Trainings/add-sessions`,
      data: formData,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (e) {
    throw e;
  }
};

const deleteTraining = async (id) => {
  try {
    const response = await http({
      method: "DELETE",
      url: `/trainings/${id}`,
    });
    return response;
  } catch (e) {
    throw e;
  }
};

const getTrainerRatingService = async (trainerId, courseId) => {
  try {
    const response = await http({
      method: "GET",
      url: `/trainingEvaluationScore/trainings/${trainerId}`,
      params: {
        courseId: courseId,
      },
    });
    return response;
  } catch (e) {
    throw e;
  }
};
const getTrainingById = async (id) => {
  try {
    if (id) {
      const response = await http({
        method: "GET",
        url: `/trainings/${id}`,
      });
      return response;
    }
    return;
  } catch (e) {
    throw e;
  }
};

// update training
const updateTraining = async (id, trainingData) => {
  try {
    const response = await http({
      method: "PATCH",
      url: `/trainings/${id}/update-with-sessions`,
      data: trainingData,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (e) {
    throw e;
  }
};

const trainingService = {
  getTrainingsService,
  filterUsersByRole,
  createTraining,
  deleteTraining,
  addTraining,
  getTrainerRatingService,
  getTrainingById,
  updateTraining,
};

export default trainingService;
